declare global {
  interface Array<T> {
    sequentialEqual(other: T[]): boolean;
  }
}

Array.prototype.sequentialEqual = function <T>(this: T[], other: T[]): boolean {
  return this.length === other.length && this.every((v, i) => v === other[i]);
};

// a module, so that `declare global` above augments the global Array type
export {};
